import { Box, Grid, useTheme } from '@mui/material';
import { useLayoutStore } from '@store/LayoutStore';
import { navLink } from '@components/header/Header';
import { activeLinkStyle, navLinkStyle } from '@components/header/Header.styles';
import { useStore } from '@store/GlobalStore';
import { shallow } from 'zustand/shallow';
import { MobileHeaderButton } from '@components/button/MobileHeaderButton';
import { HeaderButtonProps, HeaderButtons } from '@components/header/HeaderButton';
import { MobileMenuSubMenu } from '@components/header/mobileHeader/MobileMenuSubMenu';
import { EnablePaymentPortal } from '@utils/api-client';
import { arraysOverlap } from '@utils/arrays';

type MobileHeaderMenuProps = {
  showNavLinks?: boolean;
  navLinks?: navLink[];
  buttons?: (HeaderButtonProps | React.ReactNode)[] | undefined;
  forceShowHeaderButton?: boolean;
};

export const MobileHeaderMenu = ({
  showNavLinks,
  forceShowHeaderButton,
  navLinks = [],
  buttons,
}: MobileHeaderMenuProps) => {
  const [roles] = useStore((state) => [state.roles, state.userAuth], shallow);

  const { showHeaderMenu, closeHeaderMenu } = useLayoutStore(
    (state) => ({
      showHeaderMenu: state.showHeaderMenu,
      closeHeaderMenu: state.closeHeaderMenu,
    }),
    shallow,
  );

  const theme = useTheme();
  const renderMainMenu = () => {
    return (
      <Grid
        container
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'row',
          alignContent: 'baseline',
          paddingTop: '40px',
          backgroundColor: 'primary.dark',
          position: 'fixed',
          left: 0,
          right: 0,
          zIndex: 100,
        }}
      >
        {navLinks
          ?.filter((i) => arraysOverlap(i.roles, roles))
          .map((link: navLink) => (
            <MobileMenuSubMenu
              key={link.name}
              link={link}
              roles={roles}
              lioPayEnabled={EnablePaymentPortal}
              theme={theme}
              navLinkStyle={navLinkStyle}
              activeLinkStyle={activeLinkStyle}
              closeHeaderMenu={closeHeaderMenu}
            />
          ))}
        <Box
          sx={{
            gap: 3,
            mt: 2,
            display: 'flex',
            flexDirection: 'column',
            textAlign: 'center',
            marginX: 'auto',
          }}
        >
          <HeaderButtons buttons={buttons} />
        </Box>
      </Grid>
    );
  };

  return (
    <Box sx={{ height: '100%', display: 'flex', alignItems: 'center' }}>
      {(showNavLinks || !!forceShowHeaderButton) && <MobileHeaderButton />}
      {showHeaderMenu && showNavLinks && <Box sx={{ position: 'absolute', top: '100%' }}>{renderMainMenu()}</Box>}
    </Box>
  );
};
